module.exports = __webpack_public_path__ + "static/img/dialog-prize-bg.a390d375.png";